const UpsellView = () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/UpsellView.vue')

export const upsellInstances = [
	{
		id: 'upsell-static-subscription-activated',
		config: () =>
			import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/static/upsell-static-subscription-activated'),
	},

	{
		id: 'upsell-static-assessment-result',
		config: () =>
			import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/static/upsell-static-assessment-result'),
	},

	{
		id: 'upsell-upgrade-f',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upgrades/upsell-upgrade-f'),
	},
	{
		id: 'upsell-upgrade-f-al',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upgrades/upsell-upgrade-f-al'),
	},
	{
		id: 'upsell-upgrade-pilates-f',
		config: () =>
			import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upgrades/upsell-upgrade-pilates-f'),
	},

	{
		id: 'upsell-f',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-f'),
	},
	{
		id: 'upsell-m',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-m'),
	},

	{
		id: 'upsell-activity-f',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-activity-f'),
	},
	{
		id: 'upsell-activity-m',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-activity-m'),
	},

	{
		id: 'upsell-yoga-f',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-yoga-f'),
	},
	{
		id: 'upsell-yoga-m',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-yoga-m'),
	},
	{
		id: 'upsell-yoga-m-us',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-yoga-m-us'),
	},

	{
		id: 'upsell-walking-f',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-walking-f'),
	},
	{
		id: 'upsell-walking-m',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-walking-m'),
	},

	{
		id: 'upsell-tai-chi-yoga-m',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-tai-chi-yoga-m'),
	},
	{
		id: 'upsell-tai-chi-walking-f',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-tai-chi-walking-f'),
	},

	{
		id: 'upsell-pilates-f',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-pilates-f'),
	},

	{
		id: 'upsell-chair-workouts-m',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-chair-workouts-m'),
	},

	{
		id: 'upsell-calisthenics-m',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-calisthenics-m'),
	},
	{
		id: 'upsell-calisthenics-f',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-calisthenics-f'),
	},

	// Experiments ⬇️. Move from /instances/experiments to /instances during roll-out
	{
		id: 'upsell-additional-activity-b',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-additional-activity-b'),
	},
	{
		id: 'upsell-additional-activity-c',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-additional-activity-c'),
	},
	{
		id: 'upsell-additional-fasting-b',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-additional-fasting-b'),
	},
	{
		id: 'upsell-additional-fasting-c',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-additional-fasting-c'),
	},
]

export default upsellInstances.map((instance) => ({
	path: `/upsell/${instance.id.replace('upsell-', '')}`,
	name: instance.id,
	component: {
		render: (h) =>
			h(UpsellView, {
				key: instance.id,
				props: {
					id: instance.id,
					config: instance.config,
				},
			}),
	},
	meta: {
		requiresUser: true,
	},
}))
